import {h, Fragment, FunctionalComponent} from 'preact';
import {useContext} from 'preact/hooks';
import {ApplicationContext} from '../../services/use-application-setup';
import {SHORTPOINT} from './shortpoint-logo';
import {PORT_CITY_MARKETING} from './portcitymarketing-logo';

const getLogoUrl = (utmSource: string, widgetType: 'free_widget' | 'widget') =>
  `https://userway.org?utm_source=${utmSource}&utm_medium=widget_footer&utm_campaign=${widgetType}`;

const CustomLogo = ({logoSrc}: { logoSrc: string }) => (
  <img className="userway_custom_logo" src={logoSrc} alt="Logo, decorative"/>
);

const CustomLogoLink = ({
                          link,
                          logoSrc,
                          ariaLabel,
                        }: {
  link: string;
  logoSrc: string;
  ariaLabel?: string;
}) => (
  <a className="uwaw-footer__logo-label" aria-label={ariaLabel} href={link} target="_blank">
    <CustomLogo logoSrc={logoSrc}/>
  </a>
);

export const Logo: FunctionalComponent = () => {
  const {
    config,
    paidAi,
    tunings,
    previewCustomLogo,
    noLogo,
    whiteLabelOptions,
    customBrandingOptions,
  } = useContext(ApplicationContext);

  // show logo template in the preview mode
  if (previewCustomLogo?.path) {
    return previewCustomLogo?.link ? (
      <CustomLogoLink link={previewCustomLogo.link} logoSrc={previewCustomLogo?.path}/>
    ) : (
      <CustomLogo logoSrc={previewCustomLogo?.path}/>
    );
  }

  const isCustomLogoEnvironment: boolean = !!config.current?.services?.partner && [SHORTPOINT, PORT_CITY_MARKETING].includes(config.current?.services?.partner);

  const logoHref = config.current?.services?.affiliateLink
    ?? getLogoUrl(tunings?.site_name, paidAi ? 'widget' : 'free_widget');

  // if not in preview mode and no white label logo
  if (!previewCustomLogo && !noLogo) {
    // display original UserWay logo
    if (
      !whiteLabelOptions?.wlHideLogo &&
      !customBrandingOptions.custom_logo_image_path &&
      !isCustomLogoEnvironment
    ) {
      return (
        <Fragment>
          <div class="uwaw-footer__logo">
            <a
              class="uwaw-logo-img"
              target="_blank"
              href={logoHref}
            >
              <img
                src="./frontend/images/logo.svg"
                alt="UserWay Logo - opens in a new tab"
                style="max-width: 142px;"
              />
            </a>
          </div>

          <a
            class="uwaw-footer__logo-label"
            href={logoHref}
            target="_blank"
            aria-label="Accessibility by UserWay.org - opens in a new tab"
          >
            Accessibility by UserWay.org
          </a>
        </Fragment>
      );
    }

    // display custom logo
    if (customBrandingOptions.custom_logo_image_path) {
      return customBrandingOptions.custom_logo_image_link ? (
        <CustomLogoLink
          link={customBrandingOptions.custom_logo_image_link}
          logoSrc={customBrandingOptions.custom_logo_image_path}
          ariaLabel={`Link to the ${customBrandingOptions.custom_logo_image_link_no_schema} homepage - opens in a new tab`}
        />
      ) : (
        <CustomLogo logoSrc={customBrandingOptions.custom_logo_image_path}/>
      );
    }
  }

  return null;
};
